import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useRequestQueue } from '../../../../../hooks'
import { getUserProfileTabRequestsTotalCount } from '../../UserProfileTabRequests.api'

export function useUserProfileTabRequestsCounters({ scopeFilterKey, userId }) {
  const [counters, setCounters] = useState(EMPTY_OBJECT)

  const { enqueue } = useRequestQueue()

  async function handleLoadCounters() {
    // Queued: the mount-time response must not land after a refetch-driven one.
    return enqueue(() =>
      getUserProfileTabRequestsTotalCount({ scopeFilterKey, userId })
    )
      .then(response => {
        setCounters(response?.data || EMPTY_OBJECT)

        return response
      })
      .catch(() => {
        setCounters(EMPTY_OBJECT)

        return null
      })
  }

  useEffect(() => {
    if (userId) {
      handleLoadCounters()
    }
  }, [userId])

  return { counters, handleLoadCounters }
}
